import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles(() => ({
  
  root: {
    boxSizing: "border-box",
    cursor: "text",
    background: "transparent",
  },
  moreButton: {
    whiteSpace: "nowrap",
  },
  container: {
    minHeight: 18,
  },
  readOnlyEditor: {
    padding: "7px 6px",
    borderRadius: 5,
    boxSizing: "border-box",
    fontSize: "inherit",
    fontWeight: "inherit",
    color: "inherit",
    fontFamily: "inherit",
  }
}));

export default useStyle;